import {createReplaceableElement} from "../../helpers/replaceableElement";
import {clearFeedbacksByName, fillInputsByName, getInputsByName} from "../../helpers/forms";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import createElement from "../../helpers/createElement";
import {createGrid} from "../../helpers/grids/grids";
import _ from "lodash";
import {createCellRenderer} from "../../helpers/grids/helpers";
import Swal from "sweetalert2";
import {waitUntil} from "../../helpers/waitUntil";

/**
 * @typedef Address
 * @property {string} zip
 * @property {string} website
 * @property {string} city
 * @property {string} phone
 * @property {string} street
 * @property {string} name
 * @property {string} state
 */

function initResearchersVoeOrdersProcess() {
	// Static Elements (This may only exist when CALL_CENTER_MODE == agent-only)
	const agentButtonsContainer = document.querySelector('.agent-buttons');
	const voeOrderSection = document.querySelector('.voe-order-section');
	const companySection = document.querySelector('.company-section');

	// Init form
	const formComponent = createReplaceableElement({
		element: document.querySelector('.researcher-order-form-card'),
		init() {
			initFormComponent(this.element)
		},
	});

	// Init companies grid
	const companiesDataSourceCard = document.querySelector('.companies-database-source');

	const companiesGrid = createGrid(
		document.querySelector('.companies-grid'), {
			columnDefs: [
				{
					field: 'public_id',
					headerName: 'Company',
					cellClass: 'fill-space',
					cellRenderer: createCellRenderer(params => {
						const {
							name,
							state,
							address,
							zip_code,
							website,
							email,
							city,
							phone_number,
						} = params.data;

						let websiteEmailContainer = '';
						if (website || email) {
							websiteEmailContainer = `
								<div class="d-flex website-email-container">
									${website ? `<div">${website}</div>` : ''}
									${email ? `<div>${email}</div>` : ''}
								</div>
							`
						}
						return createElement(`
							<div class="company-result">
								<div class="header-container">
									<span class="company-name">${name}</span>
								</div>
								<div class="address">
									${address}, ${city}, <span class="state-code">${state}</span>, ${zip_code}
								</div>
								<div class="phone">
									${phone_number}
								</div>
								${websiteEmailContainer}
							</div>
						`);
					}),
					autoHeight: true,
				},
				{
					field: 'public_id',
					headerName: '',
					cellClass: 'fill-space h-100',
					cellRenderer: createCellRenderer(params => {
						const {public_id} = params.data;
						const buttons = createElement(`
							<div class="w-100 h-100 d-flex">
								<button
									type="button"
									class="btn btn-primary flex-grow-1 use-company-data-button"
									title="Use existing company data"
								>
									Use Company
								</button>
							</div>
						`);

						// Init use company button
						buttons.querySelector('.use-company-data-button')
							.addEventListener('click', () => handleUseExistingCompanyRequest(public_id))

						return buttons;
					}),
					autoHeight: true,
				},
			],
			_rowName: 'Results',
			onRowDataChanged() {
				// Retrieve matches from footer
				let matches = parseInt(companiesGrid._domElement.querySelector('.total-row-count').innerHTML);
				if (isNaN(matches)) {
					matches = 0;
				}

				const matchesContainer = companiesDataSourceCard.querySelector('.matches-container');

				// Make container visible as its hidden on load
				matchesContainer.classList.remove('d-none');

				// Clear styling classes
				matchesContainer.classList.remove('badge-primary', 'badge-light');

				// Set proper style class
				matchesContainer.classList.add(
					matches > 0 ? 'badge-primary' : 'badge-light'
				);

				// Update header values
				companiesDataSourceCard.querySelector('.matches-value').innerHTML = `${matches}`;
				companiesDataSourceCard.querySelector('.matches-label').innerHTML = matches === 1 ? 'Match' : 'Matches';


			}
		},
		window['routes/researcher.companies.matches'],
		() => {
			// Get filters from current form
			return getInputsByName(formComponent.element, [
				'name',
				'address',
				'city',
				'state',
				'zip_code',
			]);
		},
	)

	// We expose the grid, so the agent view can redraw it when needed
	window.researcher_process_view_companies_grid = companiesGrid;

	const formFields = [
		// Company fields
		'id',
		'name',
		'website',
		'address',
		'city',
		'state',
		'zip_code',
		'email',
		'phone_number',
		'fax_number',
	]

	// Init Google Maps
	let googleMapContainer = document.querySelector('.google-map-container');

	/** @type {google.maps.Map} */
	let googleMapInstance;
	/** @type {HTMLInputElement} */
	let googleMapSearchInputElement;
	/** @type {google.maps.places.SearchBox} */
	let googleMapSearchInstance;
	/** @type {google.maps.Marker} */
	let googleMapMarker = undefined;

	let googleMapsInfoWindow = new google.maps.InfoWindow();

	initGoogleMaps();

	/**
	 * Methods
	 */

	const updateCompanyMatches = _.debounce(
		() => {
			companiesGrid._refresh();
		},
		512,
		{
			leading: false,
			trailing: true,
		}
	);

	/**
	 * @param {Element} domElement
	 */
	function initFormComponent(domElement) {
		// Refresh company matches on input change
		const inputsToRefreshCompanies = [
			'address',
			'city',
			'state',
			'zip_code',
		];

		inputsToRefreshCompanies.forEach(name => {
			const input = domElement.querySelector(`input[name="${name}"]`);
			if (input) {
				input.addEventListener('change', () => updateCompanyMatches())
				input.addEventListener('keyup', () => updateCompanyMatches())
			}
		})

		// Handle buttons
		const sendToCallQueueButton = domElement.querySelector('.send-to-call-queue-button');
		sendToCallQueueButton.addEventListener('click', handleSendToCallQueueRequest)

		const cantProcessButton = domElement.querySelector('.cant-process-order-button');
		if (cantProcessButton) {
			cantProcessButton.addEventListener('click', handleCantProcessOrderRequest);
		}

		const backToVoeOrderSectionButton = domElement.querySelector('.back-to-voe-order-view-button');
		if (backToVoeOrderSectionButton) {
			backToVoeOrderSectionButton.addEventListener('click', displayVoeOrderSection);
		}

	}

	function initGoogleMaps() {
		// Init instance
		googleMapInstance = new google.maps.Map(
			googleMapContainer.querySelector('.google-map-instance'),
			{
				// US center
				zoom: 3,
				center: {lat: 37.0902, lng: -95.7129},
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
			}
		);

		// Init search input
		googleMapSearchInputElement = googleMapContainer.querySelector('.search');
		googleMapSearchInstance = new google.maps.places.SearchBox(googleMapSearchInputElement);

		// Prefill input with initial query
		googleMapSearchInputElement.value = getInitialQuery();

		// Bias the SearchBox results towards current map's viewport.
		googleMapInstance.addListener("bounds_changed", () => {
			googleMapSearchInstance.setBounds(googleMapInstance.getBounds());
		});

		initMapFromQuery(googleMapSearchInputElement.value);

		// Add listener for place selection
		googleMapSearchInstance.addListener("places_changed", () => {
			const places = googleMapSearchInstance.getPlaces();
			if (!places || places.length === 0) {
				return;
			}

			displayLocation(places[0]);
		});
	}

	function formatText(text) {
		return `${text}, `;
	}

	function getInitialQuery() {
		let textToSearch = '';

		const fieldsToSearch = [
			'#display_company_name',
			'input[name="address"]',
			'input[name="city"]',
			'input[name="state"]',
			'input[name="zip_code"]',
		];

		fieldsToSearch.forEach(field => {
			const fieldValue = formComponent.element.querySelector(field).value;
			if (fieldValue) {
				textToSearch += formatText(formComponent.element.querySelector(field).value);
			}
		});

		// Clean up result
		textToSearch = textToSearch.replace(/(^\s+)|(,*\s+$)/, '');

		return textToSearch;
	}

	function getGooglePlacesService() {
		return new google.maps.places.PlacesService(googleMapInstance);
	}

	function initMapFromQuery(query) {
		if (query === '') return;

		const request = {
			query: query,
			fields: ['name', 'geometry'],
		};

		loading(googleMapContainer)
		// Get first result and place as marker if possible
		getGooglePlacesService().textSearch(request, (results, status) => {
			if (
				status === google.maps.places.PlacesServiceStatus.OK &&
				results[0]
			) {
				displayLocation(results[0])
			} else {
				stopLoading(googleMapContainer)
			}
		})
	}

	/**
	 *
	 * @param {google.maps.places.PlaceResult} placeResult
	 */
	function displayLocation(placeResult) {
		// Get place details
		const detailsRequest = {
			placeId: placeResult.place_id,
			fields: [
				"name",
				"formatted_address",
				"formatted_phone_number",
				"place_id",
				"geometry",
				"website"
			],
		}

		getGooglePlacesService().getDetails(
			detailsRequest,
			(placeDetails, status) => {
				if (
					status === google.maps.places.PlacesServiceStatus.OK &&
					placeDetails &&
					placeDetails.geometry &&
					placeDetails.geometry.location
				) {
					// Center on location
					googleMapInstance.setCenter(placeDetails.geometry.location);

					// Zoom to location TODO: Improve this
					googleMapInstance.setZoom(17);

					// Place marker
					createMarker(placeDetails);

					stopLoading(googleMapContainer);
				}
			}
		);
	}

	/**
	 * @param {google.maps.places.PlaceResult} placeResult
	 */
	function createMarker(placeResult) {
		// Clear existing marker
		if (googleMapMarker) {
			googleMapMarker.setMap(null);
		}

		if (!placeResult.geometry || !placeResult.geometry.location) return;

		const address = createAddressObject(placeResult);

		const new_marker = new google.maps.Marker({
			map: googleMapInstance,
			position: placeResult.geometry.location,
		});

		google.maps.event.addListener(new_marker, "click", () => {
			googleMapsInfoWindow.setContent(createInfoWindowContent(address));
			googleMapsInfoWindow.open({
				anchor: new_marker,
				map: googleMapInstance,
				shouldFocus: true
			});
		});

		// Display info
		google.maps.event.trigger(new_marker, 'click');
	}

	/**
	 *
	 * @param {google.maps.places.PlaceResult} place
	 * @return {Address}
	 */
	function createAddressObject(place) {
		let state = '';
		let zip = '';

		const addressSplit = place.formatted_address.split(', ');
		let street = addressSplit[0] ? addressSplit[0] : '';
		let city = addressSplit[1] ? addressSplit[1] : '';
		if (addressSplit[2]) {
			const statePostal = addressSplit[2].split(' ');
			state = statePostal[0] ? statePostal[0] : '';
			zip = statePostal[1] ? statePostal[1] : '';

		}

		return {
			name: place.name,
			street,
			city,
			state,
			zip,
			phone: place.formatted_phone_number,
			website: place.website
		};
	}

	/**
	 * Creates the markers content displayed upon click
	 *
	 * @param {Address} address
	 * @return {Element}
	 */
	function createInfoWindowContent(address) {
		const infoContent = createElement(`
			<div class="px-3 py-1">
				<button class="btn btn-primary w-100 use-address-button" type="button">Use This Address</button>
				<hr class="my-1">
				<b>Name: </b>${address.name || ''}<br>
				<b>Street: </b>${address.street || ''}<br>
				<b>City: </b>${address.city || ''}<br>
				<b>State: </b>${address.state || ''}<br>
				<b>Zip/Postal: </b>${address.zip || ''}<br>
				<b>Phone: </b>${address.phone || ''}<br>
				<b>Website: </b><a href="${address.website || '#'}" target="_blank" about="_blank">${address.website || ''}</a><br>
			</div>
		`);

		infoContent.querySelector('.use-address-button')
			.addEventListener('click', () => handleAddressRetrieval(address))

		return infoContent;
	}

	/**
	 * Fills company form with the values from an address object
	 *
	 * @param {Address} address
	 */
	function handleAddressRetrieval(address) {
		const values = {};
		const fieldsToRetrieveMap = {
			website: 'website',
			street: 'address',
			city: 'city',
			state: 'state',
			zip: 'zip_code',
			phone: 'phone_number',
		};

		Object.keys(fieldsToRetrieveMap).forEach(field => {
			// Only replace a value if its filled
			if (address[field]) {
				const fieldInForm = fieldsToRetrieveMap[field];
				values[fieldInForm] = address[field];
			}
		})

		fillInputsByName(formComponent.element, values)

		// Update companies grid
		updateCompanyMatches();
	}

	function handleSendToCallQueueRequest() {
		const formContainer = formComponent.element;
		clearFeedbacksByName(formContainer, formFields);

		loading();

		const data = getInputsByName(formContainer, formFields);

		Axios.post(window['routes/researcher.voe-orders.send-to-call-queue'], data)
			.then(response => {
				if (window['CALL_CENTER_MODE'] === 'agent-only') {
					displayVoeOrderSection();
					// Update id field
					// noinspection JSUnresolvedVariable
					fillInputsByName(formContainer, {
						id: response.data.company_id,
					})
					refreshFormCard();
				} else {
					handleAjaxSuccess(response)
				}
			})
			.catch(error => {
				handleAjaxError(error, formContainer)
			})
			.finally(stopLoading);
	}

	function handleCantProcessOrderRequest() {
		const selectElementContainer = document.querySelector('.cant-process-select').cloneNode(true);
		const selectElement = selectElementContainer.querySelector('select');

		selectElementContainer.classList.remove('template')

		// Add select when modal its ready
		waitUntil(() => document.querySelector('.swal2-show .cant-process-select-alert-container'))
			.then(() => {
				// Append select to sweet alert modal
				document.querySelector('.cant-process-select-alert-container')
					.appendChild(selectElementContainer);
			})

		// Display sweet alert modal
		Swal.fire({
			title: "Can't Process Company Because",
			html: '<div class="cant-process-select-alert-container"></div>',
			confirmButtonText: 'Submit',
			showCancelButton: true,
			cancelButtonText: 'Go Back',
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				const url = window['routes/researcher.voe-orders.cant-process']
					.replace('__STATUS__', selectElement.value);

				Axios.post(url)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})
	}

	function handleUseExistingCompanyRequest(companyId) {
		loading();

		const url = window['routes/researcher.voe-orders.link-to-existing-company'].replace('_COMPANY_', companyId);

		Axios.post(url)
			.then(response => {
				if (window['CALL_CENTER_MODE'] === 'agent-only') {
					displayVoeOrderSection();
					// Update id field
					// noinspection JSUnresolvedVariable
					fillInputsByName(formComponent.element, {
						id: response.data.company_id,
					});
					refreshFormCard();
				} else {
					handleAjaxSuccess(response)
				}
			})
			.catch(handleAjaxError)
			.finally(stopLoading);
	}

	function refreshFormCard() {
		Axios.post(window['routes/researcher.voe-orders.get-company-form-card'])
			.then(response => {
				// noinspection JSUnresolvedVariable
				formComponent.replace(
					createElement(response.data.companyFormCard)
				);
			})

	}

	function displayVoeOrderSection() {
		// Display agent buttons
		agentButtonsContainer.classList.remove('opacity-0', 'pointer-events-none');

		// Display agent section
		voeOrderSection.classList.remove('d-none');

		// Hide company section
		companySection.classList.add('d-none');

		// Refresh voe orders components
		window.agents_process_view_update_components({
			orderComponent: true,
			scriptComponent: true
		}).then()
	}
}

export {initResearchersVoeOrdersProcess}
